import { FormControl, FormGroup } from "@angular/forms";
import { SearchModelV2 } from "../search-model-v2";

export const PermSetListingSearchModel: SearchModelV2 = {
  label: {
    code: "Code",
    name: "Name",
    description: "Description",
  },
  dataType: {
    code: "string",
    name: "string",
    description: "string",
  },
  form: new FormGroup({
    code: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
  }),
  options: {
    code: {},
    name: {},
    description: {},
  },
  // query: (query) => (query) ? `(hdr.code ILIKE '%${query}%' OR hdr.name ILIKE '%${query}%' OR hdr.description ILIKE '%${query}%') AND hdr.status!='DELETED'` : ``,
  // table: 'app_perm_set_hdr',
  // queryCallbacks: {
  //     code: (code) =>
  //     code ? `hdr.code ILIKE '%${code}%'` : "",
  //     name: (name) =>
  //     name ? `hdr.name ILIKE '%${name}%'` : "",
  //     description: (description) =>
  //     description ? `hdr.description = '${description}'` : "",
  //   }
};
